// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-K":"K_power-ocean-collection-K__geOu8"};